namespace TabAurous.OMS {
    export namespace VoucherMasterService {
        export const baseUrl = 'OMS/VoucherMaster';

        export declare function Create(request: Serenity.SaveRequest<VoucherMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<VoucherMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VoucherMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VoucherMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchersForTransactions(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VoucherMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/VoucherMaster/Create",
            Update = "OMS/VoucherMaster/Update",
            Delete = "OMS/VoucherMaster/Delete",
            Retrieve = "OMS/VoucherMaster/Retrieve",
            List = "OMS/VoucherMaster/List",
            GetVouchersForTransactions = "OMS/VoucherMaster/GetVouchersForTransactions"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetVouchersForTransactions'
        ].forEach(x => {
            (<any>VoucherMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
